import { useEffect, useRef, useState } from 'react'

import { debounce } from 'lodash-es'

type Options = {
    forceRerender?: boolean
    debounceMs?: number
}

export type Dimensions = {
    width: number
    height: number
}

export const useDimensions = ({ debounceMs = 0 }: Options = {}) => {
    const dimensionsMeasurerRef = useRef<HTMLElement>(null)
    const [dimensions, setDimensions] = useState<Dimensions>({ width: 0, height: 0 })

    useEffect(() => {
        const onResize = debounce(() => {
            if (!dimensionsMeasurerRef.current) return

            const { clientWidth, clientHeight } = dimensionsMeasurerRef.current
            setDimensions({ width: clientWidth, height: clientHeight })
        }, debounceMs)

        onResize()

        window.addEventListener('resize', onResize)

        return () => {
            window.removeEventListener('resize', onResize)
        }
    }, [debounceMs])

    return { dimensionsMeasurerRef, dimensions }
}
